import * as React from 'react'

import { Path } from './Path'
import { SpinnerWrapper } from './SpinnerWrapper'

export interface SpinnerProps {
  color?: string
  size?: number
}

export const Spinner: React.FunctionComponent<SpinnerProps> = props => (
  <SpinnerWrapper {...props}>
    <Path color={props.color} />
  </SpinnerWrapper>
)

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/index.tsx